import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-heart-pulse-line",
    title: "Diabetes Management",
    description:
      "Comprehensive Type 1 & Type 2 diabetes care with personalized treatment plans and continuous monitoring.",
    color: "bg-teal-50 text-teal-700",
    link: "/consultation",
  },
  {
    icon: "ri-shield-check-line",
    title: "Thyroid Disorders",
    description:
      "Expert diagnosis and treatment of hypothyroidism, hyperthyroidism, thyroid nodules, and autoimmune conditions.",
    color: "bg-emerald-50 text-emerald-700",
    link: "/consultation",
  },
  {
    icon: "ri-mental-health-line",
    title: "Hormonal Health",
    description:
      "Adrenal, pituitary, and reproductive hormone evaluations with evidence-based treatment protocols.",
    color: "bg-amber-50 text-amber-700",
    link: "/consultation",
  },
  {
    icon: "ri-book-open-line",
    title: "Spiritual Counseling",
    description:
      "Faith-based counseling sessions integrating scripture, prayer, and pastoral guidance for life's challenges.",
    color: "bg-rose-50 text-rose-700",
    link: "/ministry",
  },
  {
    icon: "ri-group-line",
    title: "Bible Study Groups",
    description:
      "Weekly in-person and online Bible study groups focused on healing, faith, and community building.",
    color: "bg-orange-50 text-orange-700",
    link: "/ministry",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Prayer Ministry",
    description:
      "Intercessory prayer services, healing prayer sessions, and community prayer events throughout the year.",
    color: "bg-stone-50 text-stone-700",
    link: "/ministry",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs tracking-widest uppercase text-amber-700 font-semibold">
            What We Offer
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-800 mt-3 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Comprehensive Care
          </h2>
          <p className="text-stone-500 max-w-xl mx-auto text-base leading-relaxed">
            Bridging the gap between medical science and spiritual wellness —
            treating every dimension of who you are.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.link}
              className="group p-8 rounded-2xl border border-stone-100 hover:border-amber-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer bg-white"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${service.color} mb-5 text-xl`}
              >
                <i className={service.icon} />
              </div>
              <h3
                className="text-lg font-bold text-stone-800 mb-2"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {service.title}
              </h3>
              <p className="text-sm text-stone-500 leading-relaxed">
                {service.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-amber-700 text-sm font-medium group-hover:gap-2 transition-all">
                Learn more <i className="ri-arrow-right-line" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
